import { render, staticRenderFns } from "./LpProductOption.vue?vue&type=template&id=0bce15d3&scoped=true"
import script from "./LpProductOption.vue?vue&type=script&lang=js"
export * from "./LpProductOption.vue?vue&type=script&lang=js"
import style0 from "./LpProductOption.vue?vue&type=style&index=0&id=0bce15d3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bce15d3",
  null
  
)

export default component.exports